import React, { FC } from 'react'
import { Flex, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import { useProductsLocaleText } from '../../locale'

const StyledBasePrice = styled(Text)<{
  discount: number
}>`
  ${({ discount }) => `
    text-decoration: ${discount ? 'line-through' : 'none'};
  `}
`

const StyledDiscountedPrice = styled(Text)`
  ${s({
    ml: 3,
    color: 'colorFeedbackSuccess',
    fontWeight: 'bold',
  })}
`

type Props = {
  code: string
  quantity: number
  discount: number
  regularTotalPrice: string
  discountedTotalPrice: string
  discountText: string
}

export const RightAlignedVariant: FC<Props> = ({
  code,
  quantity,
  discount,
  regularTotalPrice,
  discountedTotalPrice,
  discountText,
}) => {
  const localiseCoreText = useCoreLocaleText()
  const localiseText = useProductsLocaleText()

  return (
    <Flex
      alignContent="center"
      justifyContent="space-between"
      data-testid="module-price"
      mb={6}
    >
      <Flex flexDirection="column" alignItems="end">
        <Text
          as="p"
          color={'colorTextHeadline'}
          mb={0}
          aria-label={localiseText(
            'multicard.regular_price_and_discounted_price',
            {
              regularPrice: regularTotalPrice,
              discountedPrice: discountedTotalPrice,
              code,
              discount,
            },
          )}
        >
          {quantity === 1 && (
            <Text
              marginRight={3}
              typography={{
                xs: 'typeMobileDisplay05',
                md: 'typeDesktopDisplay05',
              }}
            >
              {localiseCoreText('common.price_from')}
            </Text>
          )}
          <StyledBasePrice
            discount={discount}
            typography={{
              xs: 'typeMobileDisplay05',
              md: 'typeDesktopDisplay05',
            }}
            aria-hidden
          >
            {regularTotalPrice}
          </StyledBasePrice>
          <StyledDiscountedPrice
            typography={{
              xs: 'typeMobileDisplay05',
              md: 'typeDesktopDisplay05',
            }}
            aria-hidden
          >
            {discountedTotalPrice}
          </StyledDiscountedPrice>
        </Text>
        <Text
          as="p"
          color="colorFeedbackSuccess"
          fontWeight="bold"
          mb={0}
          aria-hidden
          typography={{ xs: 'typeMobileBodyLead', md: 'typeDesktopBodyLead' }}
          textAlign={'right'}
        >
          {discountText}
        </Text>
      </Flex>
    </Flex>
  )
}
